//This is to show the fields in the tables header or not
export const cottonPriceUploadFieldDetails = 
    [
        { fieldName: 'date', show: true },
        { fieldName: 'product_id', show: false },
        { fieldName: 'product', show: true },
        { fieldName: 'by_product_id', show: false },
        { fieldName: 'by_product', show: true },
        { fieldName: 'province_id', show: false },
        { fieldName: 'province', show: true },
        { fieldName: 'district_id', show: true },
        { fieldName: 'station_id', show: false },
        { fieldName: 'station', show: true },
        { fieldName: 'minimum', show: true },
        { fieldName: 'maximum', show: true },
        { fieldName: 'arrivals', show: true },
        { fieldName: 'arrivalsUnit', show: true}
]

export const cottonCropConditionFieldDetails = [
    { fieldName: "district", show:true},
    { fieldName: "year", show: true},
    { fieldName: "district_id", show:false},
    { fieldName: "cotton_picking_current_year", show:true},
    { fieldName: "cotton_picking_previous_year", show:false},
    { fieldName: "avg_yield_per_acre_current_year", show:true},
    { fieldName: "avg_yield_per_acre_previous_year", show:false},
    { fieldName: "pest_attacked_controlled", show:true},
    { fieldName: "pest_attacked_severe", show:false},
    { fieldName: "avg_ball_no", show:true},
    { fieldName: "crop_condition", show: true}
]

export const cottonIntentionFieldDetails = [
    { fieldName:"district", show:true},
    { fieldName:"district_id", show:true},
    { fieldName:"owner", show:true},
    { fieldName: "leaser", show:true},
    { fieldName: "year", show:true},
    { fieldName: "loosing_crop", show: true},
    { fieldName: "loosing_amount", show:true},
    { fieldName: "gaining_crop", show: true},
    { fieldName: "gaining_amount", show: true}
]

export const cottonSowingFieldDetails = [
    { fieldName: "district", show: true},
    { fieldName: "district_id", show: true},
    { fieldName: "year", show: true},
    { fieldName: "seeds", show: true},
    { fieldName: "germination", show: true},
    { fieldName: "loosing_crop", show: true},
    { fieldName: "loosing_amount", show: true},
    { fieldName: "gaining_crop", show: true},
    { fieldName: "gaining_amount", show: true}
]

export const cottonLintCotton = [
    
    { fieldName: "date", show: true},
    { fieldName: "product", show:false},
    { fieldName:"product_id", show:false},
    { fieldName:"by_product_id", show:false},
    {fieldName: "by_product", show:false},
    { fieldName:"province", show:false},
    { fieldName:"province_id", show:false},
    { fieldName:"district_id", show:false},
    { fieldName: "station_id", show:false},
    { fieldName:"rate", show:false},
    { fieldName: "station", show: true},
    { fieldName: "seller", show: true},
    { fieldName: "buyer", show: true},
    { fieldName: "quality_type", show: true},
    { fieldName: "deal_type", show: true},
    { fieldName: "c/lbs", show: true},
    { fieldName: "bales", show: true},
]

export const sugarMill = [
    { fieldName: "date", show: true},
    { fieldName: "product", show:false},
    { fieldName:"product_id", show:false},
    { fieldName:"by_product_id", show:false},
    {fieldName: "by_product", show:false},
    { fieldName:"province", show:false},
    { fieldName:"province_id", show:false},
    { fieldName:"district_id", show:false},
    { fieldName: "station_id", show:false},
    { fieldName: "lcu_id", show:false},
    { fieldName: "station", show: true},
    { fieldName: "minimum", show: true},
    { fieldName: "maximum", show: true},
    { fieldName: "mill_id", show: false},
    { fieldName: "mill_name", show: true}
]
//This is to show the fields in the tables and can be used by all
export const fieldNameValues = (arr) => {
    return arr.map((item) => item.fieldName)
}

